import React from 'react';
import { portalNavPillBase } from "../../theme/portalLayout";

interface Props {
  onClick: any,
  children: React.ReactNode;
}

function NavBarAction({onClick, children}: Props) {
  const click = (e: any) => {
    e.preventDefault();
    onClick();
  }
  return (
    <li>
      <a href="#logout"
         className={`${portalNavPillBase} text-portal-teal visited:text-portal-teal active:text-portal-teal hover:bg-super-light-grey`}
         onClick={(e) => click(e) }>
        {children}
      </a>
    </li>
  );
}

export default NavBarAction;